import {computed} from 'mobx';
import moment from 'moment';

export default class WorkOrderModel {
  id;
  store;

  dateFormat(date){
    return moment.utc(date).format('YYYY-MM-DD');
  }

  constructor(store, workOrder) {
    this.store = store;
    this.updateFromJson(workOrder);
  }

  @computed get asJson() {
    const json = {
      id: +this.id,
      title: this.title,
      maintenance_type: this.maintenance_type,
      creation_date: this.creation_date,
      scheduled_date: this.scheduled_date,
      completion_deadline: this.completion_deadline,
      created_by: this.created_by,
      assigned_to: this.assigned_to,
      ticket: this.ticket,
      station: this.station,
      priority: this.priority_id,
      status: this.status_id,
      archived: this.archived
    };

    return json;
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.title = json.title;
    this.status_id = +json.status_id || +json.status;
    this.maintenance_type = +json.maintenance_type;
    this.creation_date = this.dateFormat(json.creation_date);
    this.scheduled_date = this.dateFormat(json.scheduled_date);
    this.completion_deadline = this.dateFormat(json.completion_deadline);
    this.created_by = +json.created_by;
    this.assigned_to = +json.assigned_to;
    this.ticket = json.ticket;
    this.station = json.station;
    this.archived = json.archived;
    this.priority_id = +json.priority_id || +json.priority;
    this.assigned_to_user = json.assigned_to_user;
    this.created_by_user = json.created_by_user;
  }
}



// WEBPACK FOOTER //
// ./src/models/Maintenance/WorkOrder/WorkOrderModel.js